export interface TabletProduct {
  id: string;
  name: string;
  subtitle: string;
  tagline?: string;
  description: string;
  images: string[];
  features: string[];
  highlights: { title: string; value: string; icon: string }[];
  pdfUrl?: string;
  // Specific Tab Data Structure
  technicalData: Record<string, string>;
  mainCharacteristics: Record<string, string>;
  connectivity: Record<string, string>;
  physicalCharacteristics: Record<string, string>;
}

export const tabletProducts: TabletProduct[] = [
  {
    id: "rx-altitude",
    name: "RxAltitude",
    subtitle: "IS-Tablet / Zone 1/21",
    description: `With Realix's focus on innovation in the field of connected plant we are glad to introduce RxAltitude, an IS-Tablet especially built to be used in hazardous areas. With special focus given to ease of use while making it fully functional under most challenging environment providing maximum safety in the field.

This ATEX certified mobility device comes pre-loaded with some of the best in class communication media and integrated softwares to help clients manage and transform their plants digitally to Industry 4.0 standards. Being one of lightest device in the market it still houses a big battery which supports a longer on-field connectivity.

Ideal for IIOT: Our commitment towards Open standard solutions is well modeled into this unit. Utilizing various sensors that are out-of-the-box with this tablet helps you build a customized solution that would move you towards achieving your automation and connected plant goals.`,
    images: [
      "/images/products/tablet/rx-altitude-front-horizontal.png",
      "/images/products/tablet/rx-altitude-front-vertical.png",
    ],
    pdfUrl: "",
    features: [
      "INTRINSICALLY SAFE: Explosion Proof / ATEX Zone 1/21",
      "LIGHT WEIGHT: One of the lightest with 715gms",
      "OPERATING TEMPERATURE: -20°C to 60°C",
      "OPERATING SYSTEM: Android 14.0",
      "ULTRA-RUGGED: Dust and Water-resistant (IP68)",
      "MEMORY: 128GB ROM & 8GB RAM",
    ],
    highlights: [
      { title: "Screen", value: '8.0" IPS', icon: "ion:tablet-landscape" },
      { title: "Battery", value: "8500 mAh", icon: "ion:battery-charging" },
      { title: "OS", value: "Android 14", icon: "ion:logo-android" },
      { title: "Rating", value: "IP68", icon: "ion:water" },
    ],
    technicalData: {
      "Operating System": "Android 14.0",
      Processor: "MSM8953 (2.0GHz) Octa core",
      GPU: "Adreno 506 1920 × 1200 @ 60 fps",
      Memory: "128GB ROM & 8GB RAM",
      "External Memory": "MicroSD – Expandable up to 512GB",
    },
    mainCharacteristics: {
      Display: "8″ Rug Multi-point Display, 1920 x 1200 IPS LCD",
      "Touch Panel":
        "Multi-point Capacitive, Anti-scratch, Support handwriting",
      Battery: "8500mAh Lithium-ion battery",
      "Camera Rear": "13MP auto-focus with flashlight",
      "Camera Front": "5MP",
      "Protection Class": "IP68",
    },
    connectivity: {
      Bluetooth: "5.2 (BLE)",
      GPS: "GPS (1575.42MHz) + Glonass (1602MHZ)",
      Sensors: "L-Sensor, Compass, Gyro Sensor, G_sensor",
      NFC: "Enabled. Card reading distance: 3cm~5cm",
      WIFI: "802.11 (2.4GHz + 5GHz dual band WIFI)",
      USB: "Standard USB 2.0 Type C",
      "Video Out": "HDMI 1.4a Type C",
      "Expansion Slot": "12pin Pogo Pin",
    },
    physicalCharacteristics: {
      "Operating Temperature": "-20 °C to +60 °C",
      Dimensions: "228 x 145 x 16.5 mm",
      Weight: "715gms",
    },
  },
];
